import { render, staticRenderFns } from "./MatterRegister.vue?vue&type=template&id=0a3cdbe4&scoped=true&"
import script from "./MatterRegister.vue?vue&type=script&lang=ts&"
export * from "./MatterRegister.vue?vue&type=script&lang=ts&"
import style0 from "./MatterRegister.vue?vue&type=style&index=0&id=0a3cdbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3cdbe4",
  null
  
)

export default component.exports